import { apiClient } from './client'
import { ApiError } from './errors'
import { Vault } from './inventory'

export interface ReviewOrderFees {
  amount: number
  percentage: number
  label: string
}

export interface ReviewOrder {
  id: number
  spotPrice: number
  totalFees: number
  totalPrice: number
  quantityMg: number
  orderType: 'buy' | 'sell'
  fees: ReviewOrderFees[]
  vault?: Vault
  pricePerUnit: number
  lockedUntil?: string
  walletBalance?: number
  quantityOwned?: number
  userHasBalance?: boolean
}

export async function createReviewOrder(data: {
  productId: number
  orderType: 'buy' | 'sell'
  quantityMg: number
}): Promise<ReviewOrder> {
  try {
    const response = await apiClient.post<ReviewOrder>('review_orders', {
      product_id: data.productId,
      order_type: data.orderType,
      quantity_mg: data.quantityMg
    })
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function fetchReviewOrder(id: number): Promise<ReviewOrder> {
  try {
    const response = await apiClient.get<ReviewOrder>(`review_orders/${id}`)
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function updateReviewOrderQuantity(
  id: number,
  quantityMg: number
): Promise<ReviewOrder> {
  try {
    const response = await apiClient.patch<ReviewOrder>(`review_orders/${id}`, {
      quantity_mg: quantityMg
    })
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function updateReviewOrderVault(
  id: number,
  vaultId: number
): Promise<ReviewOrder> {
  try {
    const response = await apiClient.patch<ReviewOrder>(`review_orders/${id}`, {
      vault_id: vaultId
    })
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function createMarketTransaction(
  reviewOrderId: number
): Promise<{ buyOrderId?: number; sellOrderId?: number }> {
  try {
    // BE MarketTransactionOut: { buy_order_id, sell_order_id } (snake strings).
    const response = await apiClient.post<{
      buy_order_id?: string | number
      sell_order_id?: string | number
    }>('market_transactions', { review_order_id: reviewOrderId })
    const data = response.data ?? {}
    return {
      buyOrderId:
        data.buy_order_id != null ? Number(data.buy_order_id) : undefined,
      sellOrderId:
        data.sell_order_id != null ? Number(data.sell_order_id) : undefined
    }
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}
